<template>
  <multiselect
    class="selectExample control-select"
    :value="value"
    :options="options"
    :multiple="false"
    :allow-empty="false"
    :show-labels="false"
    :disabled="disabled"
    placeholder="Select"
    @input="$emit('input', $event)"
  >
    <template slot="singleLabel" slot-scope="{ option }">
      <span class="control-badge" :class="badgeClass(option)">{{ option }}</span>
    </template>
    <template slot="option" slot-scope="{ option }">
      <span class="control-badge" :class="badgeClass(option)">{{ option }}</span>
    </template>
  </multiselect>
</template>

<script>
export default {
  name: "ControlSelect",
  props: {
    value: { type: String, default: null },
    options: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    badgeClass(option) {
      if (option === "None") return "control-badge--none";
      if (option === "Block") return "control-badge--block";
      if (option === "Warning") return "control-badge--warning";
      return "";
    },
  },
};
</script>

<style scoped>
.control-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
}
.control-badge--none {
  background-color: rgba(130, 134, 139, 0.15);
  color: #82868b;
}
.control-badge--block {
  background-color: rgba(234, 84, 85, 0.15);
  color: #ea5455;
}
.control-badge--warning {
  background-color: rgba(255, 159, 67, 0.15);
  color: #ff9f43;
}
</style>
